import React, { useState } from "react";

const ActorCustomization = ({ formData, setFormData }) => {
  const [selectedActor, setSelectedActor] = useState("");
  const [customActorName, setCustomActorName] = useState("");
  const [customActorDescription, setCustomActorDescription] = useState("");
  const [editingIndex, setEditingIndex] = useState(null);

  const actorOptions = [
    { label: "Consommateurs", value: "consumers" },
    { label: "EDF", value: "edf" },
    { label: "Élus locaux", value: "elus-locaux" },
    { label: "Commerces locaux", value: "petit-commerce" },
    { label: "CCI", value: "industry" },
    { label: "Agriculteurs", value: "agriculture" },
    { label: "DREAL", value: "dreal" },
    { label: "OFB", value: "onb" },
    { label: "Industrie", value: "grosse-industrie" },
    { label: "Agence de l'eau", value: "agence-eau" },
    { label: "Client", value: "client" },
  ];

  const handleSaveActor = () => {
    if (!selectedActor || !customActorName) return;

    setFormData((prev) => {
      const updatedList = [...prev.custom_actor_list];

      if (editingIndex !== null) {
        // MODE ÉDITION
        updatedList[editingIndex] = {
          actor_id: selectedActor,
          custom_actor_name: customActorName,
          custom_actor_description: customActorDescription,
        };
      } else {
        // MODE AJOUT
        const alreadyAdded = updatedList.some(
          (actor) => actor.actor_id === selectedActor
        );

        if (alreadyAdded) {
          alert("Cet acteur a déjà été personnalisé !");
          return prev;
        }

        updatedList.push({
          actor_id: selectedActor,
          custom_actor_name: customActorName,
          custom_actor_description: customActorDescription,
        });
      }

      return { ...prev, custom_actor_list: updatedList };
    });

    // Reset formulaire
    resetForm();
  };

  const handleEditActor = (actor, index) => {
    setSelectedActor(actor.actor_id);
    setCustomActorName(actor.custom_actor_name || "");
    setCustomActorDescription(actor.custom_actor_description || "");
    setEditingIndex(index);
  };

  const handleRemoveCustomActor = (index) => {
    const updatedActors = formData.custom_actor_list.filter((_, i) => i !== index);
    setFormData({ ...formData, custom_actor_list: updatedActors });

    // Si on supprime l'acteur en cours d'édition
    if (editingIndex === index) {
      resetForm();
    }
  };

  const resetForm = () => {
    setSelectedActor("");
    setCustomActorName("");
    setCustomActorDescription("");
    setEditingIndex(null);
  };

  return (
    <div className="form-group">
      <label>
        <input
          type="checkbox"
          checked={formData.custom_actor}
          onChange={() => {
            const newState = !formData.custom_actor;
            setFormData((prev) => ({
              ...prev,
              custom_actor: newState,
              custom_actor_list: newState ? prev.custom_actor_list : [],
            }));
            resetForm();
          }}
        />
        Activer la personnalisation des acteurs
      </label>

      {formData.custom_actor && (
        <div className="actor-customization">

          <select
            value={selectedActor}
            disabled={editingIndex !== null}
            onChange={(e) => setSelectedActor(e.target.value)}
            className="actor-select"
          >
            <option value="">Sélectionner un acteur</option>
            {actorOptions.map((actor) => (
              <option key={actor.value} value={actor.value}>
                {actor.label}
              </option>
            ))}
          </select>

          <input
            type="text"
            placeholder="Nom personnalisé"
            value={customActorName}
            onChange={(e) => setCustomActorName(e.target.value)}
            className="input"
          />

          <textarea
            placeholder="Description personnalisée"
            value={customActorDescription}
            onChange={(e) => setCustomActorDescription(e.target.value)}
            className="custom-intro-textarea"
            rows={6}
          />

          <button
            type="button"
            onClick={handleSaveActor}
            className="add-button"
          >
            {editingIndex !== null ? "Mettre à jour" : "Ajouter"}
          </button>

          {editingIndex !== null && (
            <button
              type="button"
              onClick={resetForm}
              style={{
                marginLeft: "8px",
                backgroundColor: "#adb5bd",
                color: "#fff",
                border: "none",
                padding: "6px 10px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Annuler
            </button>
          )}

          <ul className="custom-actor-list">
            {formData.custom_actor_list.length > 0 ? (
              formData.custom_actor_list.map((actor, index) => {
                const originalActor = actorOptions.find(
                  (opt) => opt.value === actor.actor_id
                );
                const originalLabel = originalActor
                  ? originalActor.label
                  : actor.actor_id;

                return (
                  <li
                    key={index}
                    className="custom-actor-item"
                    style={{
                      marginBottom: "12px",
                      padding: "8px",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                    }}
                  >
                    <div style={{ fontWeight: "bold" }}>{originalLabel}</div>

                    <div
                      style={{
                        fontSize: "0.9em",
                        color: "#555",
                        marginTop: "4px",
                      }}
                    >
                      {actor.custom_actor_name && (
                        <div>Nom personnalisé : {actor.custom_actor_name}</div>
                      )}
                      {actor.custom_actor_description && (
                        <div>
                          Description : {actor.custom_actor_description}
                        </div>
                      )}
                    </div>

                    <div style={{ marginTop: "6px" }}>
                      <button
                        type="button"
                        onClick={() => handleEditActor(actor, index)}
                        style={{
                          marginRight: "6px",
                          backgroundColor: "#4dabf7",
                          color: "#fff",
                          border: "none",
                          padding: "4px 8px",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                      >
                        Modifier
                      </button>

                      <button
                        type="button"
                        onClick={() => handleRemoveCustomActor(index)}
                        style={{
                          backgroundColor: "#ff6b6b",
                          color: "#fff",
                          border: "none",
                          padding: "4px 8px",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                      >
                        Supprimer
                      </button>
                    </div>
                  </li>
                );
              })
            ) : (
              <p>Aucun acteur personnalisé ajouté.</p>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ActorCustomization;
